document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.classList.add('vk-ready');

  const smoothLinks = document.querySelectorAll('[data-vk-scroll]');

  smoothLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      const targetSelector = link.getAttribute('data-vk-scroll');

      if (!targetSelector) return;

      const target = document.querySelector(targetSelector);

      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});

/* VK LED — Recently viewed and continue-shopping discovery */
(() => {
  const KEY = 'vk_recent_products_v1';
  const MAX = 12;
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.filter(item => item && typeof item.url === 'string' && item.url.startsWith('/products/') && !/^404(?:\s+Not\s+Found)?$/i.test((item.title || '').trim())) : [];
    } catch (_) { return []; }
  };
  const write = value => {
    try { localStorage.setItem(KEY, JSON.stringify(value.slice(0, MAX))); } catch (_) {}
  };
  const text = (selector) => {
    const node = document.querySelector(selector);
    return node ? (node.content || node.textContent || '').trim() : '';
  };
  const recordCurrent = () => {
    if (!location.pathname.startsWith('/products/')) return;
    const handle = location.pathname.split('/products/')[1].split(/[?#/]/)[0];
    if (!handle) return;
    const title = text('meta[property="og:title"]') || text('h1');
    const image = text('meta[property="og:image"]');
    const money = text('.price-item--sale:not([hidden])') || text('.price__sale .price-item--last') || text('.price-item--regular') || text('meta[property="product:price:amount"]');
    const item = { handle, url: '/products/' + handle, title: title.replace(/\s*[–—|-]\s*VK LED\s*$/i, ''), image, price: money, seenAt: Date.now() };
    write([item, ...read().filter(x => x.handle !== handle)]);
  };
  const make = (tag, className, value) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value) node.textContent = value;
    return node;
  };
  const normalizeImage = value => {
    if (typeof value !== 'string' || !value.trim()) return '';
    if (value.startsWith('//')) return 'https:' + value;
    if (value.startsWith('http://')) return 'https://' + value.slice(7);
    return value;
  };
  const getProductJson = url => new Promise(resolve => {
    try {
      const request = new XMLHttpRequest();
      request.open('GET', url + '.js', true);
      request.setRequestHeader('Accept', 'application/json');
      request.onload = () => {
        if (request.status < 200 || request.status >= 300) return resolve(null);
        try { resolve(JSON.parse(request.responseText)); } catch (_) { resolve(null); }
      };
      request.onerror = () => resolve(null);
      request.send();
    } catch (_) {
      resolve(null);
    }
  });
  const hydrate = async items => {
    const hydrated = await Promise.all(items.map(async item => {
      try {
        const product = await getProductJson(item.url);
        if (!product) return null;
        return {
          ...item,
          available: product.available,
          title: product.title || item.title || 'VK LED product',
          image: normalizeImage(product.featured_image || product.images?.[0] || item.image || ''),
          price: Number.isFinite(product.price) ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR' }).format(product.price / 100) : item.price
        };
      } catch (_) {
        return null;
      }
    }));
    const valid = hydrated.filter(Boolean);
    // Keep browsing history intact when a product fetch fails temporarily.
    return valid;
  };
  const render = async () => {
    if (document.querySelector('.vk-recently-viewed')) return;
    const currentHandle = location.pathname.startsWith('/products/') ? location.pathname.split('/products/')[1].split(/[?#/]/)[0] : '';
    const items = (await hydrate(read())).filter(item => item.handle !== currentHandle);
    if (!items.length) return;
    const section = make('section', 'vk-recently-viewed');
    section.setAttribute('aria-labelledby', 'vk-recently-viewed-title');
    const head = make('div', 'vk-recently-viewed__head');
    const copy = make('div');
    copy.append(make('p', 'vk-recently-viewed__eyebrow', 'Your recent picks'));
    const heading = make('h2', '', 'Continue where you left off');
    heading.id = 'vk-recently-viewed-title';
    copy.append(heading, make('p', 'vk-recently-viewed__sub', 'Products you viewed recently, saved on this device for quicker shopping.'));
    const actions = make('div', 'vk-recently-viewed__actions');
    const clear = make('button', 'vk-recently-viewed__clear', 'Clear history');
    clear.type = 'button';
    const previous = make('button', 'vk-recently-viewed__arrow', '←');
    previous.type = 'button'; previous.setAttribute('aria-label', 'Previous recently viewed products');
    const next = make('button', 'vk-recently-viewed__arrow', '→');
    next.type = 'button'; next.setAttribute('aria-label', 'Next recently viewed products');
    actions.append(clear, previous, next);
    head.append(copy, actions);
    const track = make('div', 'vk-recently-viewed__track');
    track.setAttribute('role', 'list');
    items.forEach(item => {
      const card = make('a', 'vk-recently-viewed__card');
      card.href = item.url;
      card.setAttribute('role', 'listitem');
      const media = make('div', 'vk-recently-viewed__image');
      if (typeof item.image === 'string' && (/^https:\/\//.test(item.image) || /^\/\//.test(item.image))) {
        const img = document.createElement('img');
        img.src = item.image; img.alt = item.title || 'Recently viewed VK LED product'; img.loading = 'lazy'; img.decoding = 'async';
        media.append(img);
      } else {
        const fallback = make('span', 'vk-recently-viewed__fallback', 'VK LED');
        fallback.setAttribute('aria-hidden', 'true');
        media.append(fallback);
      }
      const body = make('div', 'vk-recently-viewed__body');
      body.append(make('strong', '', item.title || 'VK LED product'));
      if (item.price) body.append(make('span', 'vk-recently-viewed__price', item.price));
      if (item.available === false) body.append(make('span', 'vk-recently-viewed__availability', 'Currently unavailable'));
      body.append(make('span', 'vk-recently-viewed__cta', 'View product →'));
      card.append(media, body);
      track.append(card);
    });
    previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .82, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .82, behavior: 'smooth' }));
    clear.addEventListener('click', () => { localStorage.removeItem(KEY); section.remove(); });
    section.append(head, track);
    const recentVideoAnchor = document.querySelector('[data-vk-recent-video-commerce]');
    const footer = document.querySelector('.shopify-section-group-footer-group, footer');
    if (recentVideoAnchor) recentVideoAnchor.parentNode.insertBefore(section, recentVideoAnchor);
    else if (footer) footer.parentNode.insertBefore(section, footer);
    else document.body.append(section);
  };
  const init = async () => { recordCurrent(); await render(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* Hide merchant setup placeholders from customers while retaining editor sections */
(function(){
 function hideSetup(root){
  root=root||document;
  root.querySelectorAll('section,.shopify-section').forEach(function(section){
   var text=(section.textContent||'').replace(/\s+/g,' ').trim();
   if(/COLLECTION REQUIRED Select a product collection/i.test(text) || /Add a showroom, factory, product or team image/i.test(text)){
    section.hidden=true;section.setAttribute('aria-hidden','true');
   }
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){hideSetup(document);},{once:true});else hideSetup(document);
 document.addEventListener('shopify:section:load',function(e){hideSetup(e.target);});
})();

/* VKLED RECENTLY VIEWED DATA CLEANUP 2026-08-21 */
